// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 변수 정의 */
:root {
  --bg-dark: #1a1a1a;
  --bg-panel: #252526;
  --bg-canvas: #333333;
  --border-color: #3c3c3c;
  --text-color: #e0e0e0;
  --accent-color: #0078d7;
  --tool-hover: #3e3e3e;
  --tool-active: #094771;
  --ui-scale: 1;
  
  /* 스케일에 따른 크기 조정 */
  --toolbar-height: calc(48px * var(--ui-scale));
  --left-panel-width: calc(48px * var(--ui-scale));
  --right-panel-width: calc(220px * var(--ui-scale));
  --font-size-base: calc(14px * var(--ui-scale));
  --padding-base: calc(8px * var(--ui-scale));
}

.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.main-container {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  height: calc(100vh - var(--toolbar-height));
}

/* 툴바 */
.toolbar {
  height: var(--toolbar-height);
  padding: var(--padding-base);
  background-color: var(--bg-panel);
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
}

.toolbar-group {
  display: flex;
  align-items: center;
  margin-right: calc(20px * var(--ui-scale));
}

.toolbar-button {
  background-color: transparent;
  border: none;
  color: var(--text-color);
  padding: calc(6px * var(--ui-scale)) calc(12px * var(--ui-scale));
  margin: 0 calc(2px * var(--ui-scale));
  border-radius: 4px;
  cursor: pointer;
  font-size: var(--font-size-base);
}

.toolbar-button:hover:not(.disabled) {
  background-color: var(--tool-hover);
}

.toolbar-button.active {
  background-color: var(--tool-active);
}

.toolbar-button.disabled {
  opacity: 0.3;
  cursor: not-allowed;
  color: #888888;
}

.zoom-display {
  margin: 0 calc(10px * var(--ui-scale));
  font-size: var(--font-size-base);
  color: var(--text-color);
}

.scale-label {
  color: var(--text-color);
  font-size: var(--font-size-base);
  margin-right: calc(8px * var(--ui-scale));
}

.scale-select {
  background-color: var(--bg-dark);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: calc(4px * var(--ui-scale)) calc(8px * var(--ui-scale));
  font-size: var(--font-size-base);
  cursor: pointer;
}

/* 좌측 패널 */
.left-panel {
  width: var(--left-panel-width);
  background-color: var(--bg-panel);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  padding: var(--padding-base) 0;
}

.tool-button {
  width: calc(36px * var(--ui-scale));
  height: calc(36px * var(--ui-scale));
  margin: calc(4px * var(--ui-scale)) auto;
  background-color: transparent;
  border: none;
  color: var(--text-color);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tool-button:hover {
  background-color: var(--tool-hover);
}

.tool-button.active {
  background-color: var(--tool-active);
}

.tool-icon {
  width: calc(20px * var(--ui-scale));
  height: calc(20px * var(--ui-scale));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(18px * var(--ui-scale));
}

/* 우측 패널 */
.right-panel {
  width: var(--right-panel-width);
  background-color: var(--bg-panel);
  border-left: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
}

.panel-section {
  border-bottom: 1px solid var(--border-color);
}

.panel-header {
  padding: var(--padding-base);
  font-weight: 500;
  font-size: var(--font-size-base);
  background-color: var(--bg-dark);
  border-bottom: 1px solid var(--border-color);
}

/* 팔레트 섹션 */
.palette-section {
  height: auto;
  display: flex;
  flex-direction: column;
}

.color-picker {
  padding: var(--padding-base);
  display: flex;
  align-items: center;
}

.current-color {
  width: calc(36px * var(--ui-scale));
  height: calc(36px * var(--ui-scale));
  border: 1px solid var(--border-color);
  border-radius: 4px;
  margin-right: calc(10px * var(--ui-scale));
}

.color-input {
  height: calc(28px * var(--ui-scale));
  width: calc(28px * var(--ui-scale));
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
}

.add-color-button {
  background-color: var(--tool-hover);
  border: none;
  color: var(--text-color);
  width: calc(28px * var(--ui-scale));
  height: calc(28px * var(--ui-scale));
  border-radius: 4px;
  cursor: pointer;
  margin-left: calc(10px * var(--ui-scale));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-base);
}

.palette-section-header {
  padding: calc(8px * var(--ui-scale)) calc(10px * var(--ui-scale));
  font-size: calc(12px * var(--ui-scale));
  background-color: var(--bg-dark);
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}

.palette-help {
  font-size: calc(10px * var(--ui-scale));
}

.custom-palette {
  display: flex;
  flex-wrap: wrap;
  padding: var(--padding-base);
  gap: calc(4px * var(--ui-scale));
}

.palette-color {
  width: calc(24px * var(--ui-scale));
  height: calc(24px * var(--ui-scale));
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid var(--border-color);
}

/* 레이어 섹션 */
.layers-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.layers-list {
  flex: 1 1;
  overflow-y: auto;
  padding: calc(5px * var(--ui-scale));
}

.layer-item {
  display: flex;
  align-items: center;
  padding: calc(8px * var(--ui-scale));
  border-radius: 4px;
  margin-bottom: calc(2px * var(--ui-scale));
  cursor: pointer;
  font-size: calc(13px * var(--ui-scale));
}

.layer-visibility {
  margin-right: calc(8px * var(--ui-scale));
  font-size: var(--font-size-base);
}

.layer-controls {
  display: flex;
  padding: var(--padding-base);
  border-top: 1px solid var(--border-color);
}

.layer-control-button {
  background-color: transparent;
  border: none;
  color: var(--text-color);
  width: calc(28px * var(--ui-scale));
  height: calc(28px * var(--ui-scale));
  border-radius: 4px;
  cursor: pointer;
  margin-right: calc(5px * var(--ui-scale));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-base);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;;EAEb,kBAAkB;EAClB,8CAA8C;EAC9C,gDAAgD;EAChD,kDAAkD;EAClD,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,OAAO;AACP;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;EACjC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;EACxB,iEAAiE;EACjE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,gEAAgE;EAChE,gCAAgC;EAChC,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,wCAAwC;EACxC,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iEAAiE;EACjE,uCAAuC;EACvC,gCAAgC;EAChC,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC","sourcesContent":["/* 변수 정의 */\n:root {\n  --bg-dark: #1a1a1a;\n  --bg-panel: #252526;\n  --bg-canvas: #333333;\n  --border-color: #3c3c3c;\n  --text-color: #e0e0e0;\n  --accent-color: #0078d7;\n  --tool-hover: #3e3e3e;\n  --tool-active: #094771;\n  --ui-scale: 1;\n  \n  /* 스케일에 따른 크기 조정 */\n  --toolbar-height: calc(48px * var(--ui-scale));\n  --left-panel-width: calc(48px * var(--ui-scale));\n  --right-panel-width: calc(220px * var(--ui-scale));\n  --font-size-base: calc(14px * var(--ui-scale));\n  --padding-base: calc(8px * var(--ui-scale));\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n\n.main-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  height: calc(100vh - var(--toolbar-height));\n}\n\n/* 툴바 */\n.toolbar {\n  height: var(--toolbar-height);\n  padding: var(--padding-base);\n  background-color: var(--bg-panel);\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n}\n\n.toolbar-group {\n  display: flex;\n  align-items: center;\n  margin-right: calc(20px * var(--ui-scale));\n}\n\n.toolbar-button {\n  background-color: transparent;\n  border: none;\n  color: var(--text-color);\n  padding: calc(6px * var(--ui-scale)) calc(12px * var(--ui-scale));\n  margin: 0 calc(2px * var(--ui-scale));\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: var(--font-size-base);\n}\n\n.toolbar-button:hover:not(.disabled) {\n  background-color: var(--tool-hover);\n}\n\n.toolbar-button.active {\n  background-color: var(--tool-active);\n}\n\n.toolbar-button.disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  color: #888888;\n}\n\n.zoom-display {\n  margin: 0 calc(10px * var(--ui-scale));\n  font-size: var(--font-size-base);\n  color: var(--text-color);\n}\n\n.scale-label {\n  color: var(--text-color);\n  font-size: var(--font-size-base);\n  margin-right: calc(8px * var(--ui-scale));\n}\n\n.scale-select {\n  background-color: var(--bg-dark);\n  color: var(--text-color);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  padding: calc(4px * var(--ui-scale)) calc(8px * var(--ui-scale));\n  font-size: var(--font-size-base);\n  cursor: pointer;\n}\n\n/* 좌측 패널 */\n.left-panel {\n  width: var(--left-panel-width);\n  background-color: var(--bg-panel);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  padding: var(--padding-base) 0;\n}\n\n.tool-button {\n  width: calc(36px * var(--ui-scale));\n  height: calc(36px * var(--ui-scale));\n  margin: calc(4px * var(--ui-scale)) auto;\n  background-color: transparent;\n  border: none;\n  color: var(--text-color);\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tool-button:hover {\n  background-color: var(--tool-hover);\n}\n\n.tool-button.active {\n  background-color: var(--tool-active);\n}\n\n.tool-icon {\n  width: calc(20px * var(--ui-scale));\n  height: calc(20px * var(--ui-scale));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(18px * var(--ui-scale));\n}\n\n/* 우측 패널 */\n.right-panel {\n  width: var(--right-panel-width);\n  background-color: var(--bg-panel);\n  border-left: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n}\n\n.panel-section {\n  border-bottom: 1px solid var(--border-color);\n}\n\n.panel-header {\n  padding: var(--padding-base);\n  font-weight: 500;\n  font-size: var(--font-size-base);\n  background-color: var(--bg-dark);\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* 팔레트 섹션 */\n.palette-section {\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.color-picker {\n  padding: var(--padding-base);\n  display: flex;\n  align-items: center;\n}\n\n.current-color {\n  width: calc(36px * var(--ui-scale));\n  height: calc(36px * var(--ui-scale));\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  margin-right: calc(10px * var(--ui-scale));\n}\n\n.color-input {\n  height: calc(28px * var(--ui-scale));\n  width: calc(28px * var(--ui-scale));\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.add-color-button {\n  background-color: var(--tool-hover);\n  border: none;\n  color: var(--text-color);\n  width: calc(28px * var(--ui-scale));\n  height: calc(28px * var(--ui-scale));\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: calc(10px * var(--ui-scale));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-base);\n}\n\n.palette-section-header {\n  padding: calc(8px * var(--ui-scale)) calc(10px * var(--ui-scale));\n  font-size: calc(12px * var(--ui-scale));\n  background-color: var(--bg-dark);\n  border-top: 1px solid var(--border-color);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.palette-help {\n  font-size: calc(10px * var(--ui-scale));\n}\n\n.custom-palette {\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--padding-base);\n  gap: calc(4px * var(--ui-scale));\n}\n\n.palette-color {\n  width: calc(24px * var(--ui-scale));\n  height: calc(24px * var(--ui-scale));\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid var(--border-color);\n}\n\n/* 레이어 섹션 */\n.layers-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.layers-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: calc(5px * var(--ui-scale));\n}\n\n.layer-item {\n  display: flex;\n  align-items: center;\n  padding: calc(8px * var(--ui-scale));\n  border-radius: 4px;\n  margin-bottom: calc(2px * var(--ui-scale));\n  cursor: pointer;\n  font-size: calc(13px * var(--ui-scale));\n}\n\n.layer-visibility {\n  margin-right: calc(8px * var(--ui-scale));\n  font-size: var(--font-size-base);\n}\n\n.layer-controls {\n  display: flex;\n  padding: var(--padding-base);\n  border-top: 1px solid var(--border-color);\n}\n\n.layer-control-button {\n  background-color: transparent;\n  border: none;\n  color: var(--text-color);\n  width: calc(28px * var(--ui-scale));\n  height: calc(28px * var(--ui-scale));\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: calc(5px * var(--ui-scale));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-base);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
